import styled, { keyframes } from "styled-components";

const fadeInUp = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  animation: ${fadeInUp} 0.2s ease-out forwards;
  gap: 4px;
  max-width: 250px;

  span {
    font-size: 12px;
    color: ${({ isModule = false }) => (!isModule ? "" : "#fff")};
  }
`;

export const DropdownItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  padding: 7px 4px;
  font-size: 14px;
  color: rgb(73, 73, 73);
  cursor: pointer;

  background: ${({ selected }) => (selected ? "#f5f5f5" : "")};
  opacity: ${({ disabled }) => (disabled ? "0.8" : "1")};

  :hover {
    background: #f5f5f5;
  }
`;
